import React from 'react'; 
import eData from '../hybriddata/popupdata.json';
import { Button } from '@progress/kendo-react-buttons';
import { MdClose } from "react-icons/md";
import styled from "styled-components";

const CloseModalButton = styled(MdClose)`
color: white;
cursor: pointer;
position: absolute;
top: 10px;
right: 10px;
width: 32px;
height: 32px;
`;

const AIPDisclaimerPopup = (props) => {

    return props.popupValue && (
        <div className="popup">
        <div className="aipdeclare-popup-inner">
            <CloseModalButton
                aria-label="Close modal"
                onClick={() =>{
                    props.setPopupValue(false);
                    props.OnCloseClick();
                }} />
            <div className='fbaPSize'>
                <div className="bgBlackYellowBorder">
                    <div className="row">
                        <div className="col-10">
                            <div className="dcPgmh">{eData.aipDeclare.header}</div>
                        </div>
                    </div>
                </div><br/>
                <p className="ft-p-txt">{eData.aipDeclare.sub}</p>

           
                <p className="ft-p-txt-b">{eData.aipDeclare.title1}</p>

                {eData.aipDeclare.declareList1.map((item, idx) => (
                <div key={idx}>
                    <div style={{ textAlign: "left", display: 'flex', flexWrap: 'wrap', paddingBottom: '10px'}}>
                        <ol style={{ listStyle: "disc", marginBottom: "0"}}>
                            <li>{item.lblname}</li>
                        </ol>
                    </div>
                </div>
                ))}

                <div style={{paddingTop:'10px'}} >
                <p className="ft-p-txt-b">{eData.aipDeclare.title0}</p>

                {eData.aipDeclare.declareList0.map((item, idx) => (
<div key={idx}>
    <div style={{ textAlign: "left", display: 'flex', flexWrap: 'wrap', paddingBottom: '10px'}}>
    <ol style={{ listStyle: "disc", marginBottom: "0"}}>
        <li>{item.lblname}</li>
    </ol>
</div>
</div>
                ))}

                </div>
                <div style={{paddingTop:'10px'}}>
                <p className="ft-p-txt-b">{eData.aipDeclare.title2}</p>
                {eData.aipDeclare.declareList2.map((item, idx) => (
                <div key={idx}>
                    <div style={{ textAlign: "left", display: 'flex', flexWrap: 'wrap', paddingBottom: '10px'}}>
                        <ol style={{ listStyle: "disc", marginBottom: "0"}}>
                            <li>{item.lblname}</li>
                        </ol>
                    </div>
                </div>
                ))}
                </div>
                <div style={{paddingTop:'10px'}}>
                <p className="ft-p-txt-b">{eData.aipDeclare.title}</p>

                {eData.aipDeclare.declareList.map((item, idx) => (
                <div key={idx}>
                    <div style={{ textAlign: "left", display: 'flex', flexWrap: 'wrap', paddingBottom: '10px'}}>
                        <ol style={{ listStyle: "disc", marginBottom: "0"}}>
                            <li>{item.lblname}</li>
                        </ol>
                    </div>
                </div>
                ))}
                <p className="ft-p-txt">{eData.aipDeclare.cbdata}</p>
                </div>
                <br/>
                <div className="row">
                    <div className="col-12" style={{ textAlign: "center" }}>
                        <Button primary={true} className="k-button btn btn-success"
                            disabled={false}
                            onClick={props.onClickProceed}>{eData.aipDeclare.btProceed}</Button>
                    </div>
                </div>
                <br/> 
            </div>
        </div>
        </div>
    )
}

export default AIPDisclaimerPopup; 
